import ReactQueryDevtools from './ReactQueryDevtools';

export default ReactQueryDevtools;
